














import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class Loader extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;

  @Prop() timer: number;
}
